import React from 'react';
import PropTypes from 'prop-types';
import PaginatedTable from '@/components/molecules/PaginatedTable/PaginatedTable';
import styles from './WheelOfFortuneAttributes.module.scss';

const WofQuestionsTable = ({data}) => {
  const columns = [
    {key: 'question', label: 'QUESTION'},
    {key: 'rightAnswer', label: 'RIGHT ANSWER'},
    {key: 'wrongAnswer1', label: 'WRONG ANSWER 1'},
    {key: 'wrongAnswer2', label: 'WRONG ANSWER 2'},
    {key: 'wrongAnswer3', label: 'WRONG ANSWER 3'}
  ];

  return (
    <PaginatedTable
      columns={columns}
      data={data}
      sortType='string'
      rowsPerPageOptions={[10, 15, 20, 25]}
      emptyMessage='No questions available. Please upload a template.'
      containerClassName={styles.leaderboardTableContainer}
      wrapperClassName={styles.tableWrapper}
      tableClassName={styles.leaderboardTable}
      sortableHeaderClassName={styles.sortableHeader}
      renderRow={(row, idx) => (
        <tr key={`${row.question}-${idx}`}>
          <td>{row.question}</td>
          <td>{row.rightAnswer}</td>
          <td>{row.wrongAnswer1}</td>
          <td>{row.wrongAnswer2}</td>
          <td>{row.wrongAnswer3}</td>
        </tr>
      )}
    />
  );
};

WofQuestionsTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      rightAnswer: PropTypes.string,
      wrongAnswer1: PropTypes.string,
      wrongAnswer2: PropTypes.string,
      wrongAnswer3: PropTypes.string
    })
  ).isRequired
};

export default React.memo(WofQuestionsTable);
